import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-announcements',
    templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.css'],
    standalone: false
})
export class AnnouncementsComponent implements OnInit {
  @Input() broadcastMessages: any;


  constructor() {
  }


  ngOnInit() {}
}
